// Opens the assessment-dates modal on the course page when the controller
// asked for it — the first visit after enrolment, and never again (the stamp
// is server-side; this file only obeys the marker).
//
// NOT IN packs/, for the reason mock_composer.js records: every file there
// becomes its own entrypoint and emits a bundle no layout loads. Imported by
// packs/application.js beside mock_request_wizard.
//
// WAITS FOR DOMContentLoaded UNCONDITIONALLY. The pack tag is `defer` and
// precedes javascript_importmap_tags in layouts/auth_user, so when this
// module runs the importmap has not yet defined window.bootstrap — the
// readyState guard mock_request_wizard uses would call setup() immediately
// and find nothing to call. onboarding.js and modal_management.js wait for
// the same reason.
//
// With the pack absent the modal simply does not open; the sidebar card
// carries the same form's link, so nothing is lost but the prompt.

function setup() {
  const modal = document.querySelector("#assessmentDatesModal[data-assessments-modal-open]");
  if (modal === null) return;
  if (typeof bootstrap === "undefined" || !bootstrap.Modal) return;

  bootstrap.Modal.getOrCreateInstance(modal).show();
}

document.addEventListener("DOMContentLoaded", setup);
